import {
  handleDeleteForum,
  handleDeleteForumCategory,
} from "../../redux/admin-slices/forums.slice";
import {
  deleteBlog,
  deleteBlogCategory,
} from "../../redux/admin-slices/blogs.slice";
import { handleDeleteWebinar } from "../../redux/admin-slices/webinars.slice";
import { hideDialog, refresher } from "../../redux/guest-slices/other.slice";
import { deleteFaqs } from "../../redux/admin-slices/faqs.slice";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../assets/js/Icons";

import {
  DELETE_BLOG,
  DELETE_BLOG_CATEGORY,
  DELETE_FAQ,
  DELETE_FORUM,
  DELETE_FORUM_CATEGORY,
  DELETE_SPECIALIST,
  DELETE_WEBINAR,
  DELETE_MEMBER,
} from "../../utils/keywords";

import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { deleteSpecialist } from "../../redux/admin-slices/specialist.slice";
import { deleteMember } from "../../redux/admin-slices/member.slice";

function Delete() {
  const dispatch = useDispatch();
  const { type, data, loadings } = useSelector((state) => state.otherSlice);

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog());
  };

  // Handle delete
  const handleDelete = () => {
    const deleteActions = {
      [DELETE_FAQ]: () => deleteFaqs(data?.faqId),
      [DELETE_BLOG]: () => deleteBlog(data?.blogId),
      [DELETE_FORUM]: () => handleDeleteForum(data?.forumId),
      [DELETE_WEBINAR]: () => handleDeleteWebinar(data?.webinarId),
      [DELETE_BLOG_CATEGORY]: () => deleteBlogCategory(data?.categoryId),
      [DELETE_FORUM_CATEGORY]: () =>
        handleDeleteForumCategory(data?.categoryId),
      [DELETE_SPECIALIST]: () => deleteSpecialist(data?.id),
      [DELETE_MEMBER]: () => deleteMember(data?.id),
    };

    const action = deleteActions[type];
    if (!action) return;

    dispatch(action())
      .unwrap()
      .then(() => {
        setTimeout(() => {
          handleClose();
          dispatch(refresher());
        }, 500);
      })
      .catch(() => {});
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          {type === DELETE_FAQ
            ? "Delete FAQs"
            : type === DELETE_BLOG
            ? "Delete Blog"
            : type === DELETE_FORUM
            ? "Delete Forum"
            : type === DELETE_WEBINAR
            ? "Delete Webinar"
            : type === DELETE_BLOG_CATEGORY
            ? "Delete Blog Category"
            : type === DELETE_FORUM_CATEGORY
            ? "Delete Forum Category"
            : type === DELETE_SPECIALIST
            ? "Delete Specialist"
            : type === DELETE_MEMBER
            ? "Delete Member"
            : null}
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "other.color1",
            position: "absolute",
          }}
          size="small"
          onClick={handleClose}
        >
          <Icons.CancelSolid />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
        }}
      >
        <Box sx={{ display: "grid", placeContent: "center", mb: 2 }}>
          <Icon
            sx={{ fontSize: "60px", overflow: "visible", color: "error.main" }}
          >
            <Icons.AlertStroke />
          </Icon>
        </Box>

        <Typography
          sx={{
            m: "0",
            color: "#333333",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
            fontFamily: "Poppins",
          }}
        >
          {type === DELETE_FAQ
            ? "Warning: This FAQs will permanently delete. Are you sure you want to proceed?"
            : type === DELETE_BLOG
            ? "Warning: This blog will permanently delete. Are you sure you want to proceed?"
            : type === DELETE_FORUM
            ? "Warning: This forum will permanently delete. Are you sure you want to proceed?"
            : type === DELETE_WEBINAR
            ? "Warning: This webinar will permanently delete. Are you sure you want to proceed?"
            : type === DELETE_BLOG_CATEGORY
            ? "Warning: This blog category will permanently delete. Are you sure you want to proceed?"
            : type === DELETE_FORUM_CATEGORY
            ? "Warning: This forum category will permanently delete. Are you sure you want to proceed?"
            : type === DELETE_SPECIALIST
            ? "Are you sure you want to delete this specialist?"
            : type === DELETE_MEMBER
            ? "Are you sure you want to delete this member?"
            : null}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          color="error"
          variant="contained"
          sx={{ minWidth: 120 }}
          endIcon={
            loadings?.delete ? (
              <CircularProgress
                size={20}
                thickness={5}
                sx={{ color: "white" }}
              />
            ) : (
              <Icons.DeleteStroke />
            )
          }
          onClick={handleDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default Delete;
